
import { Component, Mixins, Watch } from "vue-property-decorator";
import { default as MediaReferableContentMixin } from "./MediaReferableContentMixin.vue";
import { DomainRegistry } from "../../../../../../../domain";
import { ImageSourceKinds, IDocumentImageSource, ImageKinds } from "../../../../../../../domain/document";
import { IItem, IImageDrawable, instanceOfIImageDrawable } from "../../../../../../../domain/document/items";
import { ImageDrawableImageSourceAccessor } from "../accessors";

@Component
export default class MediaSelectableContentMixin extends Mixins(MediaReferableContentMixin) {
  data() {
    return {
      accessor: null as ImageDrawableImageSourceAccessor,
      error: "",
    };
  }
  accessor: ImageDrawableImageSourceAccessor;
  error: string;

  get isEditable(): boolean {
    return this.imageDrawable.isEditable;
  }

  get isClearable(): boolean {
    return !!this.imageSource && (this.imageSource.imageSourceKind !== ImageSourceKinds.None)
      && !!this.imageSource.imageSourceKind;
  }

  get supportedMediaDevices(): boolean {
    return "mediaDevices" in navigator && "getUserMedia" in navigator.mediaDevices;
  }

  get isFatal(): boolean {
    return !this.accessor;
  }

  get imageName(): string {
    return this.$configuration.behavior.collaboration.claio.imageName;
  }

  mounted() {
    this.initialize(this.item);
  }

  @Watch("item")
  onItemUpdated(newValue: IItem) {
    this.initialize(newValue);
  }

  private initialize(newValue: IItem) {
    try {
      this.accessor = new ImageDrawableImageSourceAccessor(newValue);
      this.accessor.validate();
      this.error = "";
    } catch (e) {
      this.accessor = null;
      this.error = e.message;
    }
  }

  uploadImageFile(imageText: string): void {
    DomainRegistry.document.getDocumentRepository().createImageSource(imageText)
    .then(this.updateImageSource).catch(e => {
      this.$error(
        "画像登録失敗",
        "画像の登録に失敗しました。",
        e,
      );
    });
  }

  private updateImageSource(source: IDocumentImageSource, expansion?: (source: IImageDrawable) => IImageDrawable): void {
    const item = this.accessor.set(source);
    if (!!expansion && instanceOfIImageDrawable(item)) {
      expansion(item);
    }
    this.updateItem(item);
  }

  clearSource(): void {
    DomainRegistry.document.getDocumentRepository().createEmptyImageSource()
    .then(this.updateImageSource);
  }

  registerClaioImage(patientId: string, claioImageId: string, imageDepartmentId: string, isVisibleLayer: boolean, isMovie: boolean, isSecret: boolean): void {
    DomainRegistry.document.getDocumentRepository().createImageSourceFromClaioImage(patientId, claioImageId, isVisibleLayer, isMovie, isSecret, imageDepartmentId)
    .then(imageSource => {
      if (!imageSource) { return; }
      if (isSecret) {
        // TODO: isSecret対応
        this.$notImplemented("シークレット画像への対応は未実装です。");
      }
      this.updateImageSource(imageSource, (s) => {
        s.imageKind = isMovie ? ImageKinds.ClaioMovie : ImageKinds.ClaioImage;
        s.claioImageId = claioImageId;
        s.imageDepartmentId = imageDepartmentId;
        return s;
      });
    })
    .catch(error => {
      console.error("image upload failed!!!");
      this.$error(
        this.imageName + "登録失敗",
        this.imageName + "の登録に失敗しました。",
        error,
      );
    });
  }
}
